import * as React from 'react';
import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17 7h4m-2 2V5m-3 14v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1.016c0-3.026 3.458-4.992 7-4.992s7 1.967 7 4.992M11.47 5.023A3.492 3.492 0 1 1 6.53 9.96a3.492 3.492 0 0 1 4.94-4.938"
      strokeLinecap="round"
      fill="none"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
